angular.module('unica_approvation_list.approvation_list_controllers')

.controller('ApprovationListCreateController', function(
	$rootScope, $scope, $state, $stateParams,
	ApprovationListCreateService
) {

	$rootScope.getEvent( $stateParams.event_id );

	$rootScope.approvationListData = {
		invitation_list_id: $stateParams.invitation_list_id
	};


	$scope.saveApprovationList = function() {
		$scope.showLoader();

		ApprovationListCreateService
			.create( $rootScope.approvationListData )
			.then(function(data) {
				$scope.hideLoader();

				if ( data ) {
					$scope.showSuccessMsg('Lista Approvazione aggiunta con successo!', '');
					$state.go('app.approvation_list.list', {
						event_id: $stateParams.event_id,
						invitation_list_id: $stateParams.invitation_list_id
					});
				}
			});
	};


});